export const EnquiryStatus = {
  NONE: { id: 0, label: 'None' },
  UNASSIGNED: { id: 1, label: 'Unassigned' },
  ASSIGNED: { id: 2, label: 'Assigned' },
  ACCEPTED: { id: 3, label: 'Accepted' },
  REFUSED: { id: 4, label: 'Refused' },
  DEAD: { id: 5, label: 'Dead' },
  COMPLETED: { id: 6, label: 'Completed' },
  EXPIRED: { id: 7, label: 'Expired' }
} as const

export type EnquiryStatus = (typeof EnquiryStatus)[keyof typeof EnquiryStatus]

export const EnquiryStatusById = Object.fromEntries(
  Object.values(EnquiryStatus).map((status) => [status.id, status])
) as Record<EnquiryStatus['id'], EnquiryStatus>

export enum EnquirySource {
  DEALER_NETWORK = 1,
  BRANDED_MODE = 2
}

export enum DealerStatus {
  NONE = 0,
  AWAITINGACTION = 1,
  ACCEPTED = 2,
  QUOTED = 3,
  REFUSED = 4,
  EXPIRED = 5
}
